import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ReactComponent as Left } from 'assets/icons/arrow-thick-left.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { device } from 'config/device';

export const CloseIcon = styled(Close)`
  position: absolute;
  top: 2.5rem;
  right: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  z-index: 100;
  cursor: pointer;
  fill: ${(props) => props.theme.gray};
  :hover {
    fill: ${(props) => props.theme.text};
  }
`;

export const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  padding-top: 10rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  @media ${device.mobile} {
    padding-top: 6rem;
  }

  /* Reclaim vertical space in short landscape viewports so more list
     rows are visible inside the modal, while keeping equal top/bottom space. */
  @media (max-height: 550px) and (orientation: landscape) {
    padding-top: 0;
    align-items: center;
  }

  .defaultTableWrapper {
    height: calc(100% - 100px);
    background: #ffffff;
  }
`;

type ModalMidScreenProps = {
  askUser?: boolean;
};

export const ModalMidScreen = styled.div<ModalMidScreenProps>`
  z-index: 99;
  position: relative;
  margin: 1rem;
  padding: 0 1rem 2rem 1rem;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.45);
  background-color: ${(props) => props.theme.grayLight};
  height: auto;
  width: auto;
  overflow: auto;
  ${(props) => {
    if (props.askUser) {
      return { height: 'auto', width: 'auto' };
    }
    return {
      height: '85%',
      width: '80%',
      [`@media ${device.desktop}`]: {
        width: '80%',
      },
      [`@media ${device.laptop}`]: {
        width: '80%',
      },
      [`@media ${device.tablet}`]: {
        width: '95%',
        height: '90%',
      },
      // Short landscape viewports: use most of the screen with small, even
      // margins so more list data is visible without feeling full-screen.
      ['@media (max-height: 550px) and (orientation: landscape)']: {
        width: '92%',
        height: '88%',
        margin: '1rem auto',
        paddingBottom: '0.5rem',
      },
    };
  }};

  .closeModal {
    min-height: 50px;
    position: sticky;
    top: 0px;
    width: 100%;
    z-index: 100;
    background-color: ${(props) => props.theme.grayLight};

    svg {
      top: 0;
      right: 0;
      margin: 10px;
    }

    @media (max-height: 550px) and (orientation: landscape) {
      min-height: 32px;
      svg {
        margin: 5px;
      }
    }
  }
`;

export const ModalLayout = styled(motion.div)`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
  overflow: auto;
  background-color: ${(props) => props.theme.grayLight};
  @media ${device.mobile} {
    margin-top: 6rem;
  }
`;

export const ModalContent = styled.div`
  height: calc(100% - 10rem);
  padding: 1.5rem 1rem;
  @media ${device.tablet} {
    padding: 1.5rem 0.5rem;
  }
`;

export const ArrowLeftIcon = styled(Left)`
  width: 2.5rem;
  height: 2.5rem;
  cursor: pointer;
  fill: ${(props) => props.theme.gray};
`;
export const BackContainer = styled.div`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  padding-right: 2.5rem;
  color: ${(props) => props.theme.gray};
  background: ${({ theme }) => theme.disable};
  box-shadow: ${({ theme }) => theme.shadow[2]};
  span {
    cursor: pointer;
    text-transform: uppercase;
  }
`;
export const BackWrapper = styled.div`
  grid-gap: 0.5rem;
  display: flex;
  align-items: center;
  :hover {
    color: ${(props) => props.theme.text};
    svg {
      fill: ${(props) => props.theme.text};
    }
  }
`;
